<small class="debug">{{me}}</small>
<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <mat-icon class="font-download">font_download</mat-icon>
  <mat-label>
    <span style="font-size: 15px;">syncing fonts: {{fontsPreviewed.length}} of {{totalFontsToPreview}}</span>
    <br/>
    <br/>
    @if (fontsPreviewed.length != totalFontsToPreview) {
      <span >{{'general.waitFontLoad' | transloco}}</span>
    }
  </mat-label>
  <div class="dlg-drag-handle" cdkDragHandle>
    <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
      <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  </div>
  <div class="close-icon" (click)="onClose()">
    <svg width="20px" height="20px" fill="currentColor" viewBox="0 0 121.31 122.876">
      <g>
        <path d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z"/>
      </g>
    </svg>
  </div>
</h1>
<div mat-dialog-content style="min-height: 300px; max-height: unset;">
  <div fxFlex fxLayoutAlign="space-between center" style="margin-top: 15x;">
    <div class="d-flex-center">
      <mat-icon color="warn" style="font-size: 32px; width:32px; height: 32px;">star</mat-icon>
      <mat-checkbox [checked]="isShowFavorite" labelPosition="before" (change)="toggleShowFavorites($event.checked)" style="margin-left: 12px;">
        <span>{{'general.showFavorites' | transloco}}</span>
      </mat-checkbox>
    </div>
    <mat-form-field>
      <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
      <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'])" [(ngModel)]="fontFilter" autocomplete="off"/>
      <a matSuffix aria-label="Clear" (click)="clearSelection()">
        <mat-icon>close</mat-icon>
      </a>
    </mat-form-field>
  </div>
  <div class="mat-elevation-z8">
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header> select</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <a [ngClass]="{selectedFont: row == this.selectedFont}" mat-icon-button (click)="onSelectedFontPreview(row)">
            <mat-icon>open_in_new</mat-icon>
          </a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
        <mat-cell *matCellDef="let row" (click)="onSelectedFontPreview(row)"  class="fontEntry" [ngClass]="{selectedFont: row == this.selectedFont}" >
          <label (click)="onSelectedFontPreview(row)" class="fontPreview fontEntry" [ngStyle]="{'font-family': row.name}">{{row.name}}</label><br/>
          <!-- enable below to allow capturing font style to image  -->
          <!--                   <div id="{{row.name}}" class="captureItem"                         -->
          <!--                         (click)="onCaptureFontStyle(row)" [ngStyle]="{'font-family': row.name}">-->
          <!--                        {{row.name}}-->
        <!--                    </div>-->
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="favorite">
      <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-icon (click)="toggleFavorite(row)" class="favorite" [ngStyle]="{'color': row.favorite ? '#62a8ee' : 'gray'}">star</mat-icon>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
  </mat-table>
  <mat-paginator class="mini-paginator" (page)="loadPage($event)" [pageSizeOptions]="[10, 15, 25]"></mat-paginator>
</div>
</div>
